import { $translate } from '@/utils/i18n';
export const tableConfig = {
    configuration: true,
    searchList: {
        searchTxt: [],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        selectBtn: false,
        clickState: true,
        leftOperation: false,
        height: 400,
        columns: [
            {
                label: $translate('lang.E2202211210001', { defaultText: 'BU' }),
                align: 'center',
                prop: 'ouName',
                value: '',
                filter: true,
                require: true,
                sort: true,
                width: 80
            },
            {
                label: $translate('lang.E3202201260018', { defaultText: '条码号' }),
                align: 'center',
                prop: 'serialNumber',
                value: '',
                filter: true,
                require: true,
                sort: true,
                width: 230
            },
            {
                label: $translate('lang.E3202201260001', { defaultText: '客户型号' }),
                align: 'center',
                prop: 'customerModel',
                value: '',
                filter: true,
                require: true,
                sort: true,
                width: 180
            },
            {
                label: $translate('lang.E3202201260020', { defaultText: '出货日期（短期）' }),
                align: 'center',
                prop: 'sellInDateStr',
                value: '',
                filter: true,
                require: true,
                sort: true,
                width: 180
            },
            {
                label: $translate('lang.E3202201260021', { defaultText: '出货日期1' }),
                align: 'center',
                prop: 'sellInDate1Str',
                value: '',
                filter: true,
                require: true,
                sort: true,
                width: 130
            },
            {
                label: $translate('lang.E3202201260022', { defaultText: '出货日期2' }),
                align: 'center',
                prop: 'sellInDate2Str',
                value: '',
                filter: true,
                require: true,
                sort: true,
                width: 130
            },
            {
                label: $translate('lang.E2202212160001', { defaultText: '过期时间' }),
                align: 'center',
                prop: 'sellInExpireDateStr',
                value: '',
                filter: true,
                require: true,
                sort: true,
                width: 130
            },
            {
                label: $translate('lang.E3202201260023', { defaultText: '一级代理商' }),
                align: 'center',
                prop: 'dealerName1',
                value: '',
                filter: true,
                require: true,
                sort: true,
                width: 130
            },
            {
                label: $translate('lang.E3202201260024', { defaultText: '二级代理商' }),
                align: 'center',
                prop: 'dealerName2',
                value: '',
                filter: true,
                require: true,
                sort: true,
                width: 130
            },
            {
                label: $translate('lang.E3202201260002', { defaultText: '更新人' }),
                align: 'center',
                prop: 'createUserCode',
                value: '',
                filter: true,
                require: true,
                sort: true,
                width: 130
            },
            {
                label: $translate('lang.E3202101250011', { defaultText: '更新时间' }),
                align: 'center',
                prop: 'updateTime',
                value: '',
                filter: true,
                require: true,
                sort: true,
                width: 130
            },
            {
                label: $translate('lang.E2202301150001', { defaultText: '二级代理分组' }),
                align: 'center',
                prop: 'sdGroup',
                value: '',
                filter: true,
                require: true,
                sort: true,
                width: 130
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};
